import { h } from "preact";
import { useContext } from "preact/hooks";
import { Context } from "../lib/globalState";

export default function CommentsTab({ count }) {
  const {
    state: { color, followStory },
  } = useContext(Context);

  return (
    <ul className="comment-system-tabs">
      <li className="comment-section">
        <a
          href="javascript:;"
          data-tag="comments"
          className="activelink"
          style={`border-color: ${color}`}
        >
          Comment{count > 1 && "s"}{" "}
          {count > 0 && (
            <span className="badge badge-default comment-count">({count})</span>
          )}
        </a>
      </li>

      {/* Only show if followStory is true in widget settings */}
      {followStory && (
        <li className="follow-section">
          <a href="" data-tag="follow" className="follow-story">
            Follow Story
          </a>
        </li>
      )}
    </ul>
  );
}
